import { render, staticRenderFns } from "./ImportPaymentsSidebar.vue?vue&type=template&id=24890d3a"
import script from "./ImportPaymentsSidebar.vue?vue&type=script&lang=js"
export * from "./ImportPaymentsSidebar.vue?vue&type=script&lang=js"
import style0 from "./ImportPaymentsSidebar.vue?vue&type=style&index=0&id=24890d3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports